import * as React from "react";
import { cn } from "@web/lib/utils";

function ScrollArea({ className, children, ...props }: React.ComponentProps<"div">) {
  return (
    <div data-slot="scroll-area" className={cn("scroll-area overflow-auto overscroll-contain", className)} {...props}>
      {children}
    </div>
  );
}

export { ScrollArea };
